var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.32,207.94s10.37,73.52-42.21,132S265.5,415.52,197.8,431.1,70.73,416.31,52.59,359s31.22-82.92,48-154.19S111,112,164,61.33s151.35-40.47,212.88,22S444.32,207.94,444.32,207.94Z",
    style: {
      fill: "#2A9D8F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.32,207.94s10.37,73.52-42.21,132S265.5,415.52,197.8,431.1,70.73,416.31,52.59,359s31.22-82.92,48-154.19S111,112,164,61.33s151.35-40.47,212.88,22S444.32,207.94,444.32,207.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 45.91,
    y1: 351.44,
    x2: 448.96,
    y2: 351.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.91,
    y1: 275.14,
    x2: 448.96,
    y2: 275.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.91,
    y1: 198.83,
    x2: 448.96,
    y2: 198.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.91,
    y1: 122.52,
    x2: 448.96,
    y2: 122.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.55,
    y1: 79.19,
    x2: 137.55,
    y2: 351.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.81,
    y1: 79.19,
    x2: 379.81,
    y2: 351.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.54,
    y1: 180.18,
    x2: 143.55,
    y2: 183.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.63,
    y1: 126.3,
    x2: 150.16,
    y2: 176.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.59,
    y1: 134.45,
    x2: 173.92,
    y2: 161.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.17,
    y1: 180.18,
    x2: 387.18,
    y2: 183.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.26,
    y1: 126.3,
    x2: 393.79,
    y2: 176.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 444.22,
    y1: 134.45,
    x2: 417.55,
    y2: 161.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.86,
    y1: 334.28,
    x2: 36.87,
    y2: 337.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.95,
    y1: 280.39,
    x2: 43.48,
    y2: 330.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.91,
    y1: 288.54,
    x2: 67.24,
    y2: 315.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.13,
    y1: 114.99,
    x2: 76.13,
    y2: 118.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.21,
    y1: 61.1,
    x2: 82.74,
    y2: 111.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.18,
    y1: 69.25,
    x2: 106.51,
    y2: 96.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.13,
    y1: 114.99,
    x2: 298.13,
    y2: 118.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.21,
    y1: 61.1,
    x2: 304.74,
    y2: 111.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.18,
    y1: 69.25,
    x2: 328.51,
    y2: 96.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.48,
    y1: 259.45,
    x2: 229.49,
    y2: 262.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.57,
    y1: 205.57,
    x2: 236.1,
    y2: 255.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.53,
    y1: 213.72,
    x2: 259.86,
    y2: 241.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.88,156.68h55.94a18.5,18.5,0,0,1,18.5,18.5V336.69a0,0,0,0,1,0,0H186.38a0,0,0,0,1,0,0V175.17A18.5,18.5,0,0,1,204.88,156.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.28,431.2l-49.09-14.44V400.69h-2.77V341.36H229.7v59.33h-2.77v15.64L177.84,431.2v2.35h.66a4.65,4.65,0,0,0-.57,2.26,4.78,4.78,0,1,0,7.37-4l.1-.1,45-5.41v6.48a4.78,4.78,0,1,0,7.38,0v-6.48l44.9,5.4a4.78,4.78,0,1,0,6.64,1.86h1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.7,
    y: 336.59,
    width: 100.02,
    height: 21.89,
    rx: 7.28,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.81,
    y: 301.09,
    width: 69.47,
    height: 38.63,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,189.91l-10.64,4.17s3.85,23.91,9,36.25,23.91,31.93,23.91,31.93,9.72-14.19,13.11-25.45-.15-42.89-.15-42.89a22.37,22.37,0,0,0-7.87-2.78C250.71,190.37,228.18,189.91,228.18,189.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.52 206.73 243.44 216.18 235.28 234.19 248.39 253.93 256.41 235.88 246.69 215.83 251.78 207.03 244.53 199.78 238.52 206.73",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,188.83l-3.4.93-3.24,5.7,8,22.68,13.12-13.57,14.34,14.65s1.7-22.83,1.7-25.45-2.31-3.55-4-4S229.73,188.83,229.73,188.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,189.76s1.47,20.51,10,38.56c4.41,9.3,12.65,22.37,12.65,21.91s8.17-24.68,8.48-32.86,1.85-25.61,1.85-25.61,15.82,6.3,19.6,8.49c5.86,3.39,13.26,4.16,13.11,8.17-.06,1.46.94,11,2.21,22.63.2,1.85,10.13,17.72,10.34,19.64,2.13,19.37-5.1,27.53-5.46,27.62-.61.15-13.42,0-13.42,0s6.95,31.62,8,33.32l1.08,1.69H239.66l-2.3-6.94-2.05,6.94H178.66l7.56-34.4h-8.33s-2.16-4.32.77-20.52,12.81-56.77,12.81-58.15S223.09,193.15,226.33,189.76Z",
    style: {
      fill: "#2A9D8F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.11,
    y1: 269.91,
    x2: 237.36,
    y2: 306.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.34,256.09c9.11-8.48,13.12-25.45,13.12-25.45l-8.18-3.55,7.87-3.86-6.8-29c-3.85-3.32-6.11-3.23-6-2.5,0,0-1.54,17.43-1.85,25.61S249,249.77,249,250.23s-9.07-12.26-12.65-21.91c-8.34-22.46-9.94-36-10.18-38.59a.24.24,0,0,0-.38-.18c-1.15.68-4,1.24-6,3-.56,4-1.28,9.8-1.78,16.18-.92,11.88-.92,17.12-.92,17.12l10.64,2.63-7.56,4.32s8.33,8.48,15.27,14.81S247,256.24,247,256.24l-8.89,13.67S250.24,264.58,259.34,256.09Z",
    style: {
      fill: "#2A9D8F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,178.65v13.27s3.4,11.1,15.43,11.87c12.65.82,14.81-11.41,14.81-11.41V180.65S235,186.36,228.18,178.65Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.35,160.75s.46-6,4.16-6,3.71,6.94,2.78,9.72-5.71,4.78-7.25,2.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,130.72s-13.63-.5-18.34,3-3.72,12.89-3.72,15.86,2.23,28.5,3.72,32.22S240,191.18,249.46,189s12.39-8.92,12.88-12.39.5-30,0-36.92S252.68,131.46,246,130.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.48,142.4c0-1.1-.08-2-.14-2.76-.49-6.94-9.66-8.18-16.35-8.92,0,0-13.63-.5-18.34,3s-3.72,12.89-3.72,15.86c0,1.19.36,6,.89,11.56A1.76,1.76,0,0,0,227.4,160c1-2.73-.49-5.2.75-8.67s1.73-5.7,4.71-7.44a25.54,25.54,0,0,1,5.94-2.47s-6.19,7.18,7.44,6.93C255.09,148.15,260.08,146.31,262.48,142.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.7,155.05s2.31,10.95.15,12-3.54,1.39-5.4-2.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.67,166.92s-.47,5.1,9.87,4.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91,155.28c0,1.06-.45,1.93-1,1.93s-1-.87-1-1.93.45-1.93,1-1.93S239.91,154.21,239.91,155.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,155.28c0,1.06-.45,1.93-1,1.93s-1-.87-1-1.93.45-1.93,1-1.93S255.41,154.21,255.41,155.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27,159.83h-8.38a1.87,1.87,0,0,1-1.83-1.52l-1.1-5.89h13.88l-.72,5.78A1.87,1.87,0,0,1,242.27,159.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.17,159.83h-8.38a1.86,1.86,0,0,1-1.83-1.52l-1.11-5.89h13.89L262,158.2A1.87,1.87,0,0,1,260.17,159.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.84,
    y1: 152.42,
    x2: 248.85,
    y2: 152.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.96,
    y1: 152.42,
    x2: 224.33,
    y2: 155.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.87,160.75s-.46-6-4.17-6-3.7,6.94-2.77,9.72,5.7,4.78,7.25,2.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.82,237.73a17.31,17.31,0,0,0-7.4-4.13,5.58,5.58,0,0,0-2.79-.22c-1.24,0-7.39-2.22-8.93-2.68s-2.47,1.08-2,2.78,3.76,3.14,5,3.45.71.34.71.34,2,4.94,1.08,6.79-4.17,6-3.09,8.95,2.78,4.47,6.17,4.47,5.4.15,6.17,0,14.5,6.63,13,6.79-.62-13.73-.62-13.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.66,245.91s7.25-3.55,10.8-7.1,4.78-4.47,6-4.78,6.17-1.7,7.4-2.78,2.16.93.31,2.47a30.17,30.17,0,0,1-4.32,2.93c-.77.47-1.54,2.63-1.54,2.63s7.56-3.24,10.18-2.47,5.22,3.11,5.06,4.49-.64.72-2.34.56-4.11-.89-6-.12-4,2.63-4,3.4,2.16,1.23,3.86,1.08,2.93-.62,4.62-.31,3.09,1.23,3.24,2.16-.61.92-2.47,1.08-5.09.31-6.17,1.08-6.63,3.39-5.7,4.32,1.48.93,3.33.93,3.83-1.42,4.91-1.34c1.45.11,2.23.22,2.23.22s2.57.11,2.34,1.12c-.36,1.62-1.22,1.67-4.95,1.84-2.92.14-3.7-.15-6.32.47a26,26,0,0,1-6.94,1.23c-4.48.31-12.5-1.85-12.5-1.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.77,235.84s-3.12-2.91-4.91-3-7.25,4.69-8,6.48,1,1.11,2.45.67,5.36-2.24,6.7-2.79a5.13,5.13,0,0,1,3.53-.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.79,242.2s-4.46-2.23-7.25-1-6.25,3.69-6.25,4.8.56.9,3,.78,6.85-.83,7.44-.86a15.49,15.49,0,0,1,2.61.53",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,228.79l-3.86,20.67s33.48-6.64,34.71-5.71,2.35,25.46,2.35,25.46-43.23,7.55-48.32,9.25-10.34,2-12.19.46-2-5.4-.62-13,14.66-62.78,14.66-62.78",
    style: {
      fill: "#2A9D8F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.79,227.4l1.39,23.6-11.11-.46L272,270.1s30.62,7.13,32.32,8,1.39-.92,3.39-3.86,3.71-9.25,3.55-12-6.48-12-6.63-11.57",
    style: {
      fill: "#2A9D8F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 284.18,
    y1: 251,
    x2: 294.52,
    y2: 251,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.34,
    y1: 249.46,
    x2: 187.61,
    y2: 254.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,416.71s-2.24,9.63-5.37,13-6,5.6-5.82,8.28l.22,2.69h32.22V432.6c0-4.7-2-13-2-16.33s-20.14.22-20.14.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.2,435.29a4.3,4.3,0,0,0-.77,2.68l.22,2.69h32.22v-5.37Z",
    style: {
      fill: "#586166",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.59,331.24s3.13-19.91-2.24-29.08-24.17-9.4-34.68-3.14-14.6,16.53-10.8,29.73,12.59,13.46,12.59,13.46-2.24,18.12-2.24,25.28,7.61,51.69,7.61,51.69H225S232.14,340.64,232.59,331.24Z",
    style: {
      fill: "#586166",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.46,
    y1: 342.21,
    x2: 199.69,
    y2: 323.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,416.71s2.24,9.63,5.37,13,6,5.6,5.82,8.28l-.22,2.69H248.5V432.6c0-4.7,2-13,2-16.33s20.14.22,20.14.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.16,435.29a4.31,4.31,0,0,1,.78,2.68l-.22,2.69H248.5v-5.37Z",
    style: {
      fill: "#586166",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,331.24s-3.13-19.91,2.24-29.08,24.17-9.4,34.68-3.14,14.69,16.53,10.88,29.73-12.67,13.46-12.67,13.46,2.24,18.12,2.24,25.28-7.61,51.69-7.61,51.69H249.39S242.23,340.64,241.78,331.24Z",
    style: {
      fill: "#586166",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.91,
    y1: 342.21,
    x2: 274.67,
    y2: 323.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.62,94.17h44.26a4.72,4.72,0,0,1,4.72,4.72v20.54a4.72,4.72,0,0,1-4.72,4.72H318.59l3.47,9.4-10.93-9.4H287.62a4.72,4.72,0,0,1-4.72-4.72V98.89A4.72,4.72,0,0,1,287.62,94.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.83,
    cy: 108.6,
    r: 2.57,
    style: {
      fill: "#2A9D8F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 308.52,
    cy: 108.6,
    r: 2.57,
    style: {
      fill: "#2A9D8F"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.22,
    cy: 108.6,
    r: 2.57,
    style: {
      fill: "#2A9D8F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.67 261.3 107.9 277.71 129.93 277.71 137.7 262.1 115.67 261.3",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.04 261.3 115.67 261.3 123.45 277.71 171.81 277.71 164.04 261.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.18,
    y: 300.31,
    width: 10.9,
    height: 140.29,
    style: {
      fill: "#a3a3a3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.08,
    y: 300.67,
    width: 10.9,
    height: 140.29,
    style: {
      fill: "#a3a3a3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 277.26,
    width: 366.96,
    height: 135.21,
    style: {
      fill: "#a3a3a3",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.81,
    y: 277.26,
    width: 366.96,
    height: 14.07,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.47,
    y: 277.26,
    width: 385.65,
    height: 8.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.69,401.14s-24.77-52.76-19.38-54.29S68,353.73,68,353.73,34.86,265,43.43,258.16,68,286.45,68,286.45s-17.09-54.29-15.08-74.94,23.72-.76,23.72-.76-17.39-74.17-1.25-78S91,217.63,91,217.63s5.3-63.46,11.77-45.88-7.13,76.47-7.13,76.47,8.87-19.88,13.8-1.53-9.8,92.51-9.8,92.51,12.52-12.23,13.69,3.06S87.42,405,87.42,405L72.1,406.49Z",
    style: {
      fill: "#2A9D8F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,401.14s-24.77-52.76-19.38-54.29S68,353.73,68,353.73,34.86,265,43.43,258.16,68,286.45,68,286.45s-17.09-54.29-15.08-74.94,23.72-.76,23.72-.76-17.39-74.17-1.25-78S91,217.63,91,217.63s5.3-63.46,11.77-45.88-7.13,76.47-7.13,76.47,8.87-19.88,13.8-1.53-9.8,92.51-9.8,92.51,12.52-12.23,13.69,3.06S87.42,405,87.42,405L72.1,406.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,403.43s-20.65-36.7-16.82-43.58S74.45,369,74.45,369s-26-65-22.17-71.1,16,20.64,16,20.64-4.58-89.46,3.06-86.4S79.8,278,79.8,278s-4.59-101.7,2.3-98.64,6.11,116.22,6.11,116.22S102,252,104.27,271.92s-17.59,73.4-17.59,73.4,19.12-42.05,21.41-19.88S92.8,388.9,92.8,388.9s6.88-16.82,6.88-7.64-5.35,20.64-5.35,20.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.18,
    y: 403.14,
    width: 43.71,
    height: 37.82,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.79,147.18s-4.48,7.39-5.15,10.74.45,4.7-.45,7.16-4.69,2.47-4.69,4.93,2.68,4.7,3.58,5.37-.68,3.58.89,7.83,2.24,9.62,4.92,9.62a75,75,0,0,0,8.28-.9l1.34,8.17L371,198.42s-.22-8,4.7-11.41,14.66-22.6,8.84-35.13S354.3,136.89,343.79,147.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,137.9a17,17,0,0,0-.72,6.08,24.53,24.53,0,0,0,3.58,11.14c2.28,3.77,7.74,6.17,9.09,10.19.44,1.34,1.56,4.92,4.69,5.82s2.47.89,1.57,6.93,1.79,12.08,7.16,13.65a16,16,0,0,0,14.77-3.13c4.25-3.36,12.3-17.23,12.53-29.76.39-22.17-21.46-33-41.17-30.3A13.43,13.43,0,0,0,337.66,137.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.36,194.37a21.07,21.07,0,0,0-8.62,2c-2.5,1.32-11.19,9.62-13.43,11s-6.49.67-4,1.79,4.25,1.34,8.5-.22,13.2-4.7,15.88-4.7,12.53,1.34,13.43,1.57,6.71,2.9,6.71,2.9-2.91-6.26-6.26-9.39S366.06,194.14,361.36,194.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.09,166.53a2.3,2.3,0,0,0-1.43,2.43,30.71,30.71,0,0,1-.15,8.88c-.89,3.8,3.86,3.8,4.9-2.43C358.09,171.29,356.53,165.66,354.09,166.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.71,218.11s-2.68,1.34-2.9,7.83-11.42,52.14-12.09,59.3,3.14,11.85,9.62,14.32,18.8,6.48,21,5.37,6.49-24.17,8.05-34.24-17.23-45-18.12-46.31S318.28,218.34,316.71,218.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.26,
    y1: 271.59,
    x2: 318.95,
    y2: 289.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,353.05l15.54,86a1.93,1.93,0,0,0,2.48,1.49h0a1.94,1.94,0,0,0,1.32-2.09l-11.47-87.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,334.26s-5.82,78.53-5.82,80.77-6,25.73-6,25.73H342s1.56-3.13,1.56-9.62.68-20.36.68-21.7,17.9-70.71,17.9-70.71-.9-6.94-9.63-11S339.09,332.47,337.75,334.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.56,431.14c0-5.93.56-18,.66-21.08-7.45-4.18-12.07,1.39-12.07,1.39v0c-.13,2-.21,3.3-.21,3.56,0,2.24-6,25.73-6,25.73H342S343.56,437.63,343.56,431.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,440.76s1.56-3.13,1.56-9.62c0-2.41.1-5.85.21-9.28-1.55-1.81-4.9-4.58-8.48-.34-1.57,1.85-5.7,13.53-7.67,19.24Z",
    style: {
      fill: "#4f4f4f",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.29,421.52l1.34,19.24h4L344,421.07S339.54,415.7,335.29,421.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.08,324s-6.94,7.61-7.61,14.1,23.27,75.18,23.27,75.18a17.61,17.61,0,0,1-3.8,7.83c-3.36,4.25-8.06,10.29-8.73,14.32s0,5.37,0,5.37H324.1s5.59-14.32,7.83-17.9.89-10.52.22-13.65-6.71-75.4-6.71-75.4S320.74,318.59,305.08,324Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,422.86c1.94-3.11,1.19-8.74.51-12.22a7,7,0,0,0-6.1-1.43c-4.7,1.12-5.6,4-5.6,4a17.61,17.61,0,0,1-3.8,7.83c-3.36,4.25-8.06,10.29-8.73,14.32s0,5.37,0,5.37H324.1S329.69,426.44,331.93,422.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.93,440.76h8.17s5-12.74,7.42-17.19c-1.2-1.1-4.83-3.91-8.32-1.16-4.25,3.36-4.7,11.64-5.81,14.77C316.86,438.65,316.33,439.87,315.93,440.76Z",
    style: {
      fill: "#4f4f4f",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.2,422.41l.9,18.35H327l4.92-17.9S327.45,418.39,323.2,422.41Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.14,248.44c3.72,12.56,7.06,36.11,7.06,38.31,0,4-11.7,27.13-11.7,27.13s-13,6.71-16.11,11.41a13.83,13.83,0,0,0-.89,14.32c2.24,4.47,5.59,6.49,13,7.83s76.07,0,76.07,0,7.16-8.73,3.8-22.6c-1.56-6.46-3.26-12.07-5.14-19.91,0,0,7.38.22,12.75-4.26s5.6-11.41,5.6-16.55S404.2,236,404.2,231.76,404,222.14,400,219,386.52,211,378,206.48c-6.7-3.53-11.63-2.91-17-2.91s-11.86,4-11.86,4-29.76,7.83-32,9.17-1.44,2.7-.62,7.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.79,230.64s-9.16,53.22-9.16,56.13,5.58,18.16,5.58,18.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.72,289c-2.2,7.07-11.22,24.88-11.22,24.88s-13,6.71-16.11,11.41a13.83,13.83,0,0,0-.89,14.32c2.24,4.47,5.59,6.49,13,7.83s76.07,0,76.07,0,7.16-8.73,3.8-22.6c-1.56-6.46-3.26-12.07-5.14-19.91L383.63,289Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.45,352.14l-11.57,86.65a1.92,1.92,0,0,0,1.91,2.17h0a1.91,1.91,0,0,0,1.89-1.57l15.82-86.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,352.14l11.57,86.65a1.92,1.92,0,0,1-1.91,2.17h0a1.91,1.91,0,0,1-1.89-1.57L379,352.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,352.14l-11.57,86.65a1.92,1.92,0,0,0,1.91,2.17h0a1.92,1.92,0,0,0,1.89-1.57l15.82-86.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.5,253H327.23s-2,17-.89,31.55,3.58,33.11,3.13,45-7.16,18.35-7.16,18.35H306.2a2.9,2.9,0,0,0-2.91,2.9h0a2.91,2.91,0,0,0,2.91,2.91h87a49.54,49.54,0,0,0,7.38-28.41c-.67-17-7.38-36.25-5.15-49.9S399.5,253,399.5,253Z",
    style: {
      fill: "#2A9D8F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.37,149.09s-4.47,1.79-4.7,6-1.56,18.79-6.93,27.07,0,21.48,13.2,23.49,23.94-17.9,19-38.48S384.85,147.3,380.37,149.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 440.96,
    x2: 460.33,
    y2: 440.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployer);
export default __webpack_public_path__ + "static/media/employer.e022a2f7e1eae04c483df5ee627c608d.svg";
export { ForwardRef as ReactComponent };